import React, { createContext } from 'react'

const MenuContext = createContext({
  top: [],
  footer: [],
  popular: []
})

export default MenuContext
